/**
 * 路由渲染器说明：
 * 1.首先这是一个函数，暂且叫它renderRoutes吧；
 * 2.怎么用它呢：renderRoutes('owner', authority);
 * 3.owner啥意思：是一个标识，用来筛选出你想要的路由列表，依据就是路由的owner字段；
 * 4.authority啥意思：是一个对象。健名表示权限名称；健值是布尔值，表示有没有该权限；
 * 
 * 路由配置说明：
 * 1.必须在pages文件夹中配置，文件名必须是route.js或者是route.jsx；
 * 2.可以配置成一个对象，简称路由对象吧，也可以配置成一个数组。数组的每一项是路由对象，且数组只能是一维的；
 * 3.路由对象长这样：
  {
    exact: true,       //是否精确匹配
    path: '/a/b',      //路由地址
    owner: '/a',       //属于谁，配置成父路由，顶层路由就配成'/'吧
    authority: 'abc',  //路由权限，权限不符合不挂载该路由
    component: Abc     //路由组件
    redirect: '/a/c'   //重定向地址
  }
 **/

import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import NotFound from 'components/NotFound';

const req = require.context('../pages', true, /route\.jsx?$/);
const allRoutes = [].concat.apply([], req.keys().map(k => req(k).default));

export default (key, authority = {}) => {
  if (typeof key !== 'string') return null;
  const routes = allRoutes.filter(v => v.owner === key);
  //添加404
  routes.push({ exact: false, path: key, component: NotFound });
  return (
    <Switch>
      {routes.map(route => {
        if (JSON.stringify(authority) !== '{}') {
          if (route.authority && !authority[route.authority]) {
            return null;
          }
        }
        if (route.redirect) {
          //重定向路由
          return <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            render={() => (
              <Redirect to={route.redirect} />
            )}
          />
        } 
        //一般路由
        return <Route
          key={route.path}
          exact={route.exact}
          path={route.path}
          component={route.component}
        />
      })}
    </Switch>
  )
}
